import { render, staticRenderFns } from "./BookingTemplateLoadDialog.vue?vue&type=template&id=0af21f0c&scoped=true&"
import script from "./BookingTemplateLoadDialog.vue?vue&type=script&lang=ts&"
export * from "./BookingTemplateLoadDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTemplateLoadDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BookingTemplateLoadDialog.vue?vue&type=style&index=1&id=0af21f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af21f0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VMenu,VRow,VSimpleTable,VSpacer,VTooltip})
